<template>
  <div :class="$style.container">
    <div :class="$style.group" v-for="group in groups" :key="group.label">
      <div :class="$style.groupLabel">{{ group.label }}</div>

      <div :class="$style.items">
        <div :class="$style.item" v-for="templateGroup in group.items" :key="templateGroup.id">
          <div :class="$style.label">
            <feather-icon v-if="group.icon" :icon="group.icon" :class="$style.icon" />
            {{ templateGroup.label }}
          </div>
          <div
            v-if="templatesDict[templateGroup.id] && templatesDict[templateGroup.id].length"
            :class="$style.templates"
          >
            <ImportTab
              v-for="template in templatesDict[templateGroup.id]"
              :key="template.id"
              :template="template"
              :templateGroup="templateGroup"
              :buildingId="selectedBuildingId"
            />
          </div>
          <div :class="$style.templatesEmpty" v-else>Шаблоны не найдены</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImportTab                   from "@/components/calculated-program/import/ImportTab";
import ImportResultUserApartment   from "@/components/calculated-program/import/ImportResultUserApartment";
import ImportResultBankStatement   from "@/components/calculated-program/import/ImportResultBankStatement";
import ImportFormDevicesValues     from "@/components/calculated-program/import/ImportFormDevicesValues";
import ImportFormHeatDevicesValues from "@/components/calculated-program/import/ImportFormHeatDevicesValues";
import ImportResultDevicesValues   from "@/components/calculated-program/import/ImportResultDevicesValues";
// import ImportResultPskbImport    from "@/components/calculated-program/import/ImportResultPskbImport";

const groups = [
  {
    label: 'РАСЧЕТНАЯ ПРОГРАММА',
    // icon:  'SmartphoneIcon',
    items: [
      {
        id:     'user_apartment',
        label:  'Импорт жильцов',
        parent: 'building',
        report: ImportResultUserApartment,
      },
      {
        id:     'dismiss_user_apartment',
        label:  'Снятие с регистрации',
        parent: 'building',
      },
      {
        id:                        'bank_statement',
        label:                     'Импорт выписок',
        parent:                    'legalEntity',
        report:                    ImportResultBankStatement,
        canSaveWithoutSucceedData: true,
      },
      {
        id:                        'bank_registry',
        label:                     'Импорт реестров',
        parent:                    'legalEntity',
        report:                    ImportResultBankStatement,
        canSaveWithoutSucceedData: true,
      },
      {
        id:     'floor_importer',
        label:  'Импорт этажей',
        parent: 'building',
      },
      {
        id:     'entrance_importer',
        label:  'Импорт парадных',
        parent: 'building',
      },
      {
        id:     'import_radio',
        label:  'Импорт радио',
        parent: 'building',
      },
      {
        id:     'import_antenna',
        label:  'Импорт антенны',
        parent: 'building',
      },
      {
        id:     'import_apartments',
        label:  'Импорт помещений',
        parent: 'building',
      },
      {
        id:     'import_apartments_info',
        label:  'Импорт информации о помещениях',
        parent: 'building',
      },
      {
        id:     'devices_values',
        label:  'Импорт показаний приборов учета',
        parent: 'building',
        form:   ImportFormDevicesValues,
        report: ImportResultDevicesValues,
      },
      {
        id:     'old_heat_devices_values',
        label:  'Импорт показаний приборов учета тепла',
        parent: 'building',
        form:   ImportFormHeatDevicesValues,
        report: ImportResultDevicesValues,
      },
      {
        id:     'heat_devices_values',
        label:  'Импорт показаний приборов учета тепла',
        parent: 'building',
        form:   ImportFormHeatDevicesValues,
        report: ImportResultDevicesValues,
      },
    ],
  },
];

export default {
  name:       "ImportList",
  components: { ImportTab },
  data() {
    return {
      groups:        [],
      templatesDict: {},
    };
  },
  mounted() {
    this.loadTemplates();
  },
  computed: {
    selectedBuildingId() {
      return this.$store.getters['appUser/selectedHouse'].id;
    },
  },
  methods:  {
    loadTemplates() {
      this.$http.get('import/template', { params: { buildings_id: this.selectedBuildingId } }).then(( { data } ) => {
        const templatesDict = groups.reduce(( dict, group ) => {
          group.items.forEach(item => dict[item.id] = []);
          return dict;
        }, {});
        const unknownGroupsDict = {};

        data.forEach(template => {
          const { type } = template;
          if (!templatesDict[type]) {
            unknownGroupsDict[type] = true;
            templatesDict[type] = [];
          }
          templatesDict[type].push(template);
        });

        const localGroups = [];

        for (let i = 0; i < groups.length; i++) {
          const group = groups[i];
          const items = group.items.filter(item => templatesDict[item.id].length);
          if (items.length) {
            localGroups.push({ ...group, items });
          }
        }

        const unknownGroups = Object.keys(unknownGroupsDict);
        if (unknownGroups.length) {
          localGroups.push({
            label:  'НЕИЗВЕСТНЫЕ',
            parent: 'building',
            items:  unknownGroups.map(g => ({ id: g, label: g })),
          });
        }

        this.groups = localGroups;
        this.templatesDict = templatesDict;
      });

    },
  },
  watch:    {
    selectedBuildingId() {
      this.loadTemplates();
    },
  },
};
</script>

<style lang="scss" module>
.container {

}

.group {
  margin-bottom: 50px;

  &:last-child {
    margin-bottom: 0px;
  }
}

.groupLabel {
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 30px;
  color: #7F7F7F;
}

.items {
}

.item {
  margin-bottom: 24px;
  display: flex;
  //border: 1px solid rgba(0, 0, 0, 0.3);
}

.label {
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 7px 0px 0px 7px;
  width: 240px;
  flex-shrink: 0;
  padding: 11px;
  font-size: 14px;
  font-weight: 500;
  display: flex;
}

.icon {
  margin-right: 8px;
  width: 20px;
  height: 20px;
}

.templates {
  flex: 1;
  min-width: 0;
}

.templatesEmpty {
  flex: 1;
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-left: 0;
  border-radius: 0 7px 7px 0;
  display: flex;
  align-items: center;
  padding: 0 20px;
  font-style: italic;
  color: color(text-muted);
}

</style>
